import routes from "@/utils/routes";
import { createModel } from "@rematch/core";
import { RootModel } from ".";

interface State {
  [pathKey: string]: boolean;
}

const initialState: State = routes
  .filter((route) => route.title)
  .reduce<{ [pathKey: string]: boolean }>((finalObject, route) => {
    return { ...finalObject, [route.path!]: false };
  }, {});

export const viewGuides = createModel<RootModel>()({
  state: initialState,
  reducers: {
    setViewGuides(
      state,
      payload: {
        pathKey: string;
      }
    ) {
      return {
        ...state,
        [payload.pathKey]: true,
      };
    },
  },
});
